import React, {useCallback} from 'react';
import {useColorThemeType, useFontTheme} from '@buncha/appStyles/hooks/theme';

import {Analytics} from '@buncha/config/analytics/analytics';
import {B2BUserScreens} from '@buncha/B2B/navigation/types';
import CartIcon from '@buncha/components/core/icon/CartIcon';
import {EventType} from '@buncha/config/analytics/type';
import {H6Text} from '@buncha/components/core/text';
import {HBox} from '@buncha/components/core/view';
import {MainScreens} from '@buncha/navigation/types';
import {Modules} from '@buncha/utils/types';
import {Touchable} from '@buncha/components/core/touchable';
import {navigation} from '@buncha/config/navigation';
import {styles} from './styles';
import {useGetLocale} from '@buncha/localization/hooks';

interface ViewOrderItemButtonProps {
  orderId: string;
  runId: number;
  legacyId: number;
}

const ViewOrderItemButton: React.FC<ViewOrderItemButtonProps> = props => {
  const {orderId, runId, legacyId} = props;
  const theme = useColorThemeType();
  const muliFont = useFontTheme();
  const {button} =
    useGetLocale(Modules.B2BUserOrder, B2BUserScreens.OrderInfo) ?? {};

  const viewOrderItem = useCallback(() => {
    Analytics.eventWithProps('View Items', {
      type: EventType.cta,
      runId,
      orderId: legacyId,
      externalOrderId: orderId,
    });
    navigation.navigate(MainScreens.B2B, {
      screen: B2BUserScreens.OrderItemInfo,
      params: {
        orderId,
        runId,
        legacyId,
      },
    });
  }, [legacyId, orderId, runId]);

  return (
    <Touchable onPress={viewOrderItem}>
      <HBox
        style={[
          styles.buttonContainer,
          {backgroundColor: theme?.background.yellow[300]},
        ]}>
        <CartIcon
          width={20}
          height={20}
          viewBox="0 0 20 20"
          fill={theme?.background.blue[300]}
        />
        <H6Text
          style={[
            styles.text,
            {
              color: theme?.text.blue[300],
              fontFamily: muliFont[700].normal,
            },
          ]}>
          {button?.viewYourItems}
        </H6Text>
      </HBox>
    </Touchable>
  );
};

export default React.memo(ViewOrderItemButton);
